import React, { useEffect } from "react";
import { object, string, arrayOf } from "prop-types";
import { connect } from "react-redux";
import { LazyCollection, LazyLoadImages } from "@quintype/components";
import get from "lodash/get";

import SixteenStories3AdWithTagSearchAndLoadMore from "../../rows/SixteenStories3AdWithTagSearchAndLoadMore";
import { getCollectionTemplate } from "../../get-collection-template";
import Anchor from "../../atoms/Anchor";

import { fireVirtualPageOnSPA, collectionMenus } from "../../utils/utils";
import { useAutoRefresh } from "../../utils/react-utils";

import "./collection.m.css";

const CollectionBase = ({ data: { collection }, language, domainSlug, menus = [] }) => {
  const { slug: collectionSlug } = collection;
  const stories = collection.items?.filter((item) => item.type === "story") || [];

  const {
    "section-page-widget-url": widgetUrl,
    "height-for-mobile": widgetMobileHeight,
    "height-for-desktop": widgetDesktopHeight,
    "parent-section-slug": sectionSlug,
  } = collection?.metadata || {};

  useAutoRefresh(collection?.slug);

  const {
    children = [],
    url,
    title,
    "section-name": sectionName,
  } = (sectionSlug && collectionMenus(menus, sectionSlug)) || {};

  const widgetStyle = {
    "--parent-widget-mobile-height": widgetMobileHeight ? widgetMobileHeight + "px" : undefined,
    "--parent-widget-desktop-height": widgetDesktopHeight ? widgetDesktopHeight + "px" : undefined,
  };

  const brandTitle = (language) => {
    const brandTitle = language === "en" ? "Prothom Alo" : "প্রথম আলো";
    return brandTitle;
  };

  useEffect(() => {
    handleReload();
  }, [collection.name]);

  const handleReload = () => {
    if (document.readyState === "complete") {
      fireVirtualPageOnSPA("Collections", "Not Applicable", "", collection.name + " | " + brandTitle());
    }
  };

  const defaultCollectionName = () => {
    return (
      <div styleName="collection-meta-title-wrapper" className="collection-meta-wrapper">
        {url && (
          <Anchor aria-label={sectionName || title} href={url}>
            <h2 styleName="section-name">{sectionName || title}</h2>
          </Anchor>
        )}
        <div styleName="collection-headers">
          <h1 styleName="collection-title">{collection.name}</h1>
        </div>
        {children?.length > 0 && (
          <ul styleName="submenu">
            {children.map((item, index) => (
              <li key={index} styleName="submenu-item">
                <Anchor href={item.completeUrl} aria-label={item.title}>
                  {item.title}
                </Anchor>
              </li>
            ))}
          </ul>
        )}
      </div>
    );
  };

  return (
    <div style={widgetStyle}>
      {defaultCollectionName()}
      <div>
        {collection && collection["data-source"] === "automated" && collection.template === "default" ? (
          !stories.length ? (
            <div styleName="no-collection-stories">No stories found for this collection !!</div>
          ) : (
            <div styleName="other-collection">
              <SixteenStories3AdWithTagSearchAndLoadMore
                collectionSlug={collectionSlug}
                stories={stories}
                widgetUrl={widgetUrl}
                lang={language}
                domainSlug={domainSlug}
              />
            </div>
          )
        ) : !collection || !collection.items || !collection.items.length ? (
          <div styleName="no-collection-stories">No stories found for this collection !!</div>
        ) : (
          <LazyLoadImages>
            <LazyCollection
              collection={collection}
              widgetUrl={widgetUrl}
              collectionTemplates={getCollectionTemplate}
              lazyAfter={2}
            />
          </LazyLoadImages>
        )}
      </div>
    </div>
  );
};

CollectionBase.propTypes = {
  data: object,
  language: string,
  domainSlug: string,
  menus: arrayOf(object),
};

const mapStateToProps = (state) => ({
  language: get(state, ["qt", "config", "publisher-attributes", "lang"], "bn"),
  domainSlug: state?.qt?.config?.domainSlug,
  menus: state?.qt?.data?.navigationMenu?.menuItems || [],
});

export const CollectionPage = connect(mapStateToProps)(CollectionBase);
